<template>
  <div class="type-select">
    <div id="single" class="type-button" :class="{
      'selected-single': getType('single'),
      'disabled-button': isCurrentTeamMix}"
      @mouseenter="setType('single', 0, true)"
      @mouseout="setType('single', 0, false)"
      @click="setType('single', 1)">
      {{this.gender}}单
    </div>
    <div id="double" class="type-button" :class="{
      'selected-double': getType('double'),
      'disabled-button': isCurrentTeamMix}"
      @mouseenter="setType('double', 0, true)"
      @mouseout="setType('double', 0, false)"
      @click="setType('double', 1)">
      {{this.gender}}双
    </div>
    <div id="team" class="type-button-team" :class="{
      'selected-team': getType('team'),
      'disabled-button': isCurrentTeamMix}"
      @mouseenter="setType('team', 0, true)"
      @mouseout="setType('team', 0, false)"
         @click="setType('team', 1)"
    >
<!--      {{this.gender}}团-->
      团体
    </div>
    <div id="mixed" class="type-button" :class="{'selected-mixed': getType('mixed')}"
      @mouseenter="setType('mixed', 0, true)"
      @mouseout="setType('mixed', 0, false)"
      @click="setType('mixed', 1)">
      混双
    </div>
    <div class="type-select-tooltip" :style="{
      opacity: ['mixed', 'double'].includes(tooltipType)? 1:0,
      left: `175px`,
      top: `${tooltipType=='double'? 4:45}px`,
    }">
      {{['mixed', 'double'].includes(tooltipType)? selected[`${tooltipType}PartnerName`]:''}}
    </div>
  </div>
</template>
<script>
import { defineComponent } from 'vue';
import {getEvent} from "@/api";
import {compTypeOptions} from "@/utils/common";
export default defineComponent({
  data() {
    return {
      gender: this.values.gender==='male'?'男':'女',
      selected: {
        single: true,
        double: false,
        team: false,
        mixed: false,
        mixedPartner: '',
        doublePartner: '',
        mixedPartnerName: '',
        doublePartnerName: '',
      },
      hover: {
        single: false,
        double: false,
        team: false,
        mixed: false,
      },
      tooltipType: '',
      colId: -1,
    };
  },
  props: {
    "values": {
      type: Object,
      default: null,
    },
    "bfvalue": {
      type: Object,
      default: null,
    }
  },
  computed: {
    isCurrentTeamMix() {
      return ['mixed', 'youth_mixed'].includes(this.$store.state.currentTeam)
    }
  },
  watch: {
    values: { // 对对象进行深度监听
      handler(value) {
        if(value) {
          this.gender = value.gender==='male'?'男':'女'
          this.selected.single = value.single
          this.selected.double = value.double
          this.selected.team = value.team
          this.selected.mixed = value.mixed
          this.selected.mixedPartner = value.mixedPartner
          this.selected.doublePartner = value.doublePartner
          this.selected.mixedPartnerName = value.mixedPartnerName
          this.selected.doublePartnerName = value.doublePartnerName
          this.colId = value.colId
        }
      },
      immediate: true,
      deep: true,
    }
  },
  methods: {
    setType(type, state=0, value) {
      if(state == 1 && this.bfvalue && this.colId >= 0) {
        let comp = this.$store.state.tableCompetitions[this.colId]
        let partner = this.bfvalue.comp[this.colId]
        if((!this.$store.state.editMode) && partner.has_score) {
          let match_id = comp.match_id + ''
          const all_allowed_subtype = [...compTypeOptions['women'].map(item => item.value), ...compTypeOptions['men'].map(item => item.value), ...compTypeOptions['mix'].map(item => item.value)];
          // let subtypeCN = `${type==='team'?'团体':(type==='mixed'?'混双':(this.gender+(type==='single'?'单':'双')))}`

          let subTypeEn =this.gender === "男"?(type==='team'?'team men':(type==='mixed'?'mixed':(type==='single')?'men single':'men double')):(type==='team'?'team women':(type==='mixed'?'mixed':(type==='single')?'women single':'women double'))
          console.log('subTypeEn',subTypeEn)
          if (!all_allowed_subtype.includes(subTypeEn)){
            console.log('error subtype',subTypeEn)
          }
          let playerId = this.bfvalue.player_id + ''

          // console.log('before get event')
          this.get_eventData(match_id, subTypeEn, playerId, '', '').then(
              res=>{
                if (res){
                  this.$store.commit('setEventFilterData', {
                    'comp': comp.match_id,
                    'eventVisible': true,
                    'type': type,
                    'gender': this.bfvalue['gender'],
                    'player': ['double', 'mixed'].includes(type)?
                        [playerId, partner[`${type}_partner_id`]] : [playerId]
                  })
                }
              }
          )
            return
        }
      }

      if(this.isCurrentTeamMix && ['single', 'double', 'team'].includes(type)) {
        return
      }
      if(state == 1) {
        this.$emit('changeTypeValue', {
          'playerId': this.values.playerId,
          'competitionId': this.values.competitionId,
          'type': type,
          'value': !this.values[type]
        })
      } else {
        this.hover[type] = value
        if(this.hover.mixed && this.selected.mixed && this.selected.mixedPartner.length > 0) {
          this.tooltipType = 'mixed'
        }else if(this.hover.double && this.selected.double && this.selected.doublePartner.length > 0) {
          this.tooltipType = 'double'
        }else {
          this.tooltipType = ''
        }
      }
      // console.log('subtype')
    },
    getType(type) {
      return (this.values && this.values[type])
        // || (this.hover && this.hover[type])
    },
    getPopupContainer(triggerNode){
			return triggerNode.parentNode;
		},
    async get_eventData(match_id, subType, player_id, start_time, end_time){
      // let str_to_parse="Men's Singles - Final - Match 1"
      // let final = str_to_parse.split('-')[1].split(' ')[1]
      // console.log(final)
      try{
        const response = await getEvent(match_id,subType,player_id,start_time,end_time)
        // console.log("res",JSON.stringify(response.data.data))
        // console.log('success',response.status)
        // console.log(response.data.success)
        if (response.status === 200) {
          if(response.data.success){
            this.$store.commit('setEventData',response.data.data.subEvent)
            this.$store.commit('setMedal',response.data.data.medal)
            return true
          }
        }
      }catch (e) {
        console.log('error',e)
      }
      return false
    }
  }
});
</script>
<style lang="less" scoped>
.type-select {
  width: 200px;
  height: 90px;
  position: relative;
}
.type-button {
  width: 60px;
  height: 30px;
  position: absolute;
  border-radius: 6px;
  border: 1px solid #0072BE;
  cursor: pointer;
  font-family: 'Microsoft YaHei UI';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 28px;
  color: #00375B;
  /* or 125% */

  // display: flex;
  // align-items: center;
  text-align: center;
  letter-spacing: -0.015em;
}
.type-button-team {
  width: 60px;
  height: 30px;
  position: absolute;
  border-radius: 6px;
  border: 1px solid #0072BE;
  cursor: pointer;
  font-family: 'Microsoft YaHei UI';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 28px;
  color: #00375B;
  /* or 125% */

  // display: flex;
  // align-items: center;
  text-align: center;
  letter-spacing: -0.015em;
}
#single {
  left: 15.92%;
  right: 54.23%;
  top: 12.22%;
  bottom: 54.44%;
}
.selected-single {
  background: #0072BE;
  border: 1px solid #0072BE;
  color: white;
}
#double {
  left: 53.73%;
  right: 16.42%;
  top: 12.22%;
  bottom: 54.44%;
}
.selected-double {
  background: #9364C2;
  border: 1px solid #9364C2;
  color: white;
}
#team {
  left: 15.92%;
  right: 54.23%;
  top: 55.56%;
  bottom: 11.11%;
}
.selected-team {
  background: #00A5AF;
  border: 1px solid #00A5AF;
  color: white;
}
#mixed {
  left: 53.73%;
  right: 16.42%;
  top: 55.56%;
  bottom: 11.11%;
}
.selected-mixed {
  background: #BF936B;
  border: 1px solid #BF936B;
  color: white;
}
.disabled-button {
  background: none;
  border: 1px solid #b7b7b7;
  color: #b7b7b7;
  cursor: not-allowed;
}
/deep/ .type-select-tooltip {
  width: 72px;
  height: 38px;
  box-shadow: 0px 0px 5px 1px rgba(0, 0, 0, 0.25);
  border-radius: 6px;
  position: absolute;
  background-color:white;

  color: black;
  text-align: center;
  font-family: 'Microsoft YaHei UI';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 38px;
  z-index: 100 !important;
}
</style>
